import React, { useState, useEffect} from 'react';
import { Typography, Box, Button } from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FemaleIcon from '@mui/icons-material/Female';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import backImage from '../assets/img/back.png';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {calcEst, showEst, optionsRequired} from '../common/sharedFunctions';
import { getLangKey } from 'common/src/other/getLangKey';

const Section = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const cartypes = useSelector(state => state.cartypes);
  const [data, setData] = useState([]);
  const auth = useSelector(state => state.auth);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (cartypes.cars) {
      const visibleCars = cartypes.cars.filter(c => c.visibleInApp !== false);
      setData(visibleCars.sort((a, b) => a.pos - b.pos));
    } else {
      setData([]);
    }
  }, [cartypes.cars]);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);

  const navigate = useNavigate();
  const role = props.role;

  const isWomenOnly = (item) => {
    if (item?.womenOnly === true) return true;
    const n = `${item?.name || ''} ${item?.extra_info || ''}`.toLowerCase();
    return /mujer|women|woman|lady|solo mujeres|exclusivo mujer|púrpura|purpura/.test(n);
  };

  const shortDesc = (item) => {
    if (item?.description) return item.description;
    const name = (item?.name || '').toLowerCase();
    if (name.includes('taxi')) return 'Servicio tradicional, rápido y económico para tu día a día.';
    if (name.includes('moto')) return 'Ideal para moverte ágil en la ciudad sin tráfico.';
    if (/mujer|púrpura|purpura/.test(name)) return 'Viaja con total confianza en un ambiente exclusivo.';
    if (name.includes('vip')) return 'Máximo confort y exclusividad para tus trayectos especiales.';
    if (name === 'c2' || name.includes('c2')) return 'Comodidad y seguridad para tus trayectos con Conecta2.';
    const cleaned = String(item?.extra_info || '').replace(/^Info\.?\s*extra\s*:?\s*/i, '').trim();
    if (cleaned && !/capacidad/i.test(cleaned) && cleaned.length > 8 && cleaned.length < 120) {
      return cleaned;
    }
    return 'Comodidad y seguridad para tus trayectos con Conecta2.';
  };

  const metaLine = (item) => {
    const extra = String(item?.extra_info || '');
    const cap = extra.match(/capacidad\s*:?\s*(\d+)/i);
    const tipo = extra.match(/tipo\s*:?\s*([^,]+)/i);
    const capacity = cap ? cap[1] : (item?.capacity || item?.seats || '—');
    const typeLabel = tipo ? tipo[1].trim() : (item?.type || '—');
    return `Capacidad: ${capacity} | Tipo: ${typeLabel}`;
  };

  const featureItems = [
    {
      id: 1,
      Icon: DirectionsCarOutlinedIcon,
      title: t('pruduct_section_heading_1'),
      text: t('product_section_1'),
    },
    {
      id: 2,
      Icon: AccessTimeOutlinedIcon,
      title: t('pruduct_section_heading_2'),
      text: t('product_section_2'),
    },
    {
      id: 3,
      Icon: PeopleAltOutlinedIcon,
      title: t('pruduct_section_heading_3'),
      text: t('product_section_3'),
    },
    {
      id: 4,
      Icon: VerifiedUserOutlinedIcon,
      title: t('pruduct_section_heading_4'),
      text: t('product_section_4'),
    },
  ];

  const onCarAction = (item) => {
    if (loggedIn) {
      navigate(
        ((role && role === 'driver') || (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin')))
          ? '/bookings'
          : '/addbookings',
        { state: { carData: item } }
      );
    } else {
      navigate('/login');
    }
  };

  const Boxs = () => {
    return(
      <Box className={classes.vehicleSection}>
        <div className={classes.vehicleSectionTopRow}>
          <div className={classes.vehicleSideLabel}>
            <span>EL SERVICIO QUE TE MUEVE</span>
            <div className={classes.vehicleSideUnderline} />
          </div>
          <div className={`${classes.vehicleSideLabel} ${classes.vehicleSideLabelRight}`}>
            <span>EN TODO COLOMBIA</span>
            <div className={classes.vehicleSideUnderline} />
          </div>
        </div>

        <Typography component="h2" className={classes.vehicleSectionTitle}>
          Nuestros <span>tipos de vehículos</span>
        </Typography>
        <Typography className={classes.vehicleSectionSubtitle}>
          Elige la opción que se adapte a tus necesidades y muévete con Conecta2.
        </Typography>

        {data && data.length > 0 ? (
          <div className={classes.vehicleCardsRow}>
            {data.map((item, key) => {
              const womenOnly = isWomenOnly(item);
              return (
                <div className={classes.vehicleCard} key={item.id || key}>
                  {womenOnly ? (
                    <div className={classes.vehicleWomenBadge}>
                      <FemaleIcon sx={{ fontSize: 14 }} />
                      Solo mujeres
                    </div>
                  ) : null}
                  <div className={classes.vehicleImageWrap}>
                    <img alt={item.name || 'Vehículo'} src={item.image} className={classes.vehicleImage} />
                  </div>
                  <Typography className={classes.vehicleName}>
                    {t(getLangKey(item.name)) || item.name}
                  </Typography>
                  <Typography className={classes.vehicleDesc}>
                    {shortDesc(item)}
                  </Typography>
                  <Typography className={classes.vehicleMeta}>
                    {metaLine(item)}
                  </Typography>
                  <Button
                    className={classes.vehicleInfoBtn}
                    onClick={(e) => {
                      e.preventDefault();
                      onCarAction(item);
                    }}
                  >
                    <span>INFORMACIÓN</span>
                    <span className={classes.vehicleInfoArrow}>
                      <ArrowForwardIcon sx={{ fontSize: 16 }} />
                    </span>
                  </Button>
                </div>
              );
            })}
          </div>
        ) : (
          <Typography variant="h3" fontWeight={400} style={{ textAlign: 'center', padding: 35, color: '#6411ED'}}>
            {t('service_start_soon')}
          </Typography>
        )}
      </Box>
    )
  }

  return (
    <div>
      <Boxs/>

      <Box
        className={classes.featuresSection}
        sx={{
          backgroundImage: `url(${backImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Typography component="h2" className={classes.featuresTitle}>
          MEJOR SERVICIO <span>BRINDADO</span>
        </Typography>
        <Typography className={classes.featuresSubtitle}>
          TU MOVILIDAD, NUESTRA PRIORIDAD
        </Typography>
        <div className={classes.featuresUnderline} />

        <div className={classes.featuresGrid}>
          {featureItems.map((item) => {
            const Icon = item.Icon;
            return (
              <div className={classes.featureItem} key={item.id}>
                <div className={classes.featureIconBox}>
                  <Icon className={classes.featureIcon} />
                </div>
                <div className={classes.featureCopy}>
                  <Typography className={classes.featureTitle}>{item.title}</Typography>
                  <Typography className={classes.featureText}>{item.text}</Typography>
                </div>
              </div>
            );
          })}
        </div>
      </Box>
    </div>
  );
};

export default Section;
